<div class="modal-body">

  @for (frame of frames; track frame) {
    <div>
      <h3>{{ 'WINDOW|Konfiguracja' | translate }} {{frame.index}}</h3>
      <div>
        <span class="frame-parameter">U<sub>w</sub> : {{ (frame.uw || 0) | number:'1.3-3' }}</span>
        <span class="frame-parameter">S<sub>w</sub> : {{ (frame.sw || 0) | number:'1.3-3' }}</span>
      </div>
      <div >
        <table class="table table-condensed table-hover">
          <tr class="active">
            <td></td>
            <td>{{ 'WINDOW|Linia' | translate }}</td>
            <td colspan="2">h<sub>e</sub></td>
          </tr>
          <tr>
            <td>system</td>
            <td>#{{conf.System.id}} - {{conf.System.name}}</td>
            <td>{{ (conf.System.he || 0) | number:'1.3-3' }}</td>
          </tr>
          <tr class="active">
            <td></td>
            <td>{{ 'WINDOW|Szprosy' | translate }}</td>
            <td>{{ 'WINDOW|Duplex' | translate }}</td>
            <td>{{ 'CONFIGURATOR|Ilość' | translate }}</td>
          </tr>
          <tr>
            <td>muntins</td>
            <td>#{{conf.MuntinsData.type.id}} - {{conf.MuntinsData.type.name}}</td>
            <td>{{conf.MuntinsData.duplex}}</td>
            <td>{{muntins}}</td>
          </tr>
          <tr class="active">
            <td></td>
            <td>{{ 'WINDOW|Kolor' | translate }}</td>
            <td colspan="2">α</td>
          </tr>
          <tr>
            <td>sash.outer</td>
            @if (conf.Colors.sash.outer?.id) {
              <td>#{{conf.Colors.sash.outer.id}} - {{conf.Colors.sash.outer.name}}</td>
            }
            @if (conf.Colors.sash.outer?.id) {
              <td>{{ (conf.Colors.sash.outer.alfa || 0) | number:'1.3-3' }}</td>
            }
            @if (!conf.Colors.sash.outer?.id) {
              <td>-</td>
            }
            @if (!conf.Colors.sash.outer?.id) {
              <td>-</td>
            }
          </tr>
          <tr>
            <td>sash.core</td>
            @if (conf.Colors.sash.core?.id) {
              <td>#{{conf.Colors.sash.core.id}} - {{conf.Colors.sash.core.name}}</td>
            }
            @if (conf.Colors.sash.core?.id) {
              <td>{{ (conf.Colors.sash.core.alfa || 0) | number:'1.3-3' }}</td>
            }
            @if (!conf.Colors.sash.core?.id) {
              <td>-</td>
            }
            @if (!conf.Colors.sash.core?.id) {
              <td>-</td>
            }
          </tr>
          <tr>
            <td>frame.outer</td>
            @if (conf.Colors.frame.outer?.id) {
              <td>#{{conf.Colors.frame.outer.id}} - {{conf.Colors.frame.outer.name}}</td>
            }
            @if (conf.Colors.frame.outer?.id) {
              <td>{{ (conf.Colors.frame.outer.alfa || 0) | number:'1.3-3' }}</td>
            }
            @if (!conf.Colors.frame.outer?.id) {
              <td>-</td>
            }
            @if (!conf.Colors.frame.outer?.id) {
              <td>-</td>
            }
          </tr>
          <tr>
            <td>frame.core</td>
            @if (conf.Colors.frame.core?.id) {
              <td>#{{conf.Colors.frame.core.id}} - {{conf.Colors.frame.core.name}}</td>
            }
            @if (conf.Colors.frame.core?.id) {
              <td>{{ (conf.Colors.frame.core.alfa || 0) | number:'1.3-3' }}</td>
            }
            @if (!conf.Colors.frame.core?.id) {
              <td>-</td>
            }
            @if (!conf.Colors.frame.core?.id) {
              <td>-</td>
            }
          </tr>
        </table>
        <div class="clearfix"></div>
      </div>
      @for (sash of frame.sashes; track sash) {
        <div>
          <h4>
            {{ 'WINDOW|Kwatera' | translate }} {{sash.index}}
            @if (sash.intIndex) {
              <small>{{ 'WINDOW|pole' | translate }} {{sash.intIndex}}</small>
            }
          </h4>
          <table class="table table-condensed table-hover">
            <tr class="active">
              <td></td>
              <td>{{ 'WINDOW|Szyba' | translate }}</td>
              <td>{{ 'WINDOW|Ciepła ramka' | translate }}</td>
              <td>Ψ</td>
              <td>L</td>
              <td>A<sub>g</sub></td>
              <td>S<sub>g</sub></td>
              <td>U<sub>g</sub></td>
            </tr>
            <tr>
              <td>inner</td>
              <td>#{{sash.sash.glazing.id}} - {{sash.sash.glazing.name}}</td>
              <td>#{{conf.WarmEdge.id}} - {{conf.WarmEdge.name}}</td>
              <td>{{ sash.data.values.Psi | number:'1.3-3' }}</td>
              <td>{{ sash.data.values.L | number:'1.3-3' }}</td>
              <td>{{ sash.data.values.Ag | number:'1.3-3' }}</td>
              <td>{{ sash.data.values.Sg | number:'1.3-3' }}</td>
              <td>{{ sash.data.values.Ug | number:'1.3-3' }}</td>
            </tr>
            <tr>
              <td colspan="8"></td>
            </tr>
            <tr class="active">
              <td></td>
              <td>{{ 'WINDOW|Rama' | translate }}</td>
              <td>{{ 'WINDOW|Skrzydło' | translate }}</td>
              <td>{{ 'WINDOW|Listwa przyszybowa' | translate }}</td>
              <td colspan="2">{{ 'WINDOW|Słupek' | translate }}</td>
              <td>A<sub>f</sub></td>
              <td>S<sub>f</sub></td>
              <td>U<sub>f</sub></td>
            </tr>
            @for (join of sash.data.joins; track join; let i = $index) {
              <tr>
                <td>{{join.side}}</td>
                @if (join.confFrame) {
                  <td>#{{join.confFrame.id}} - {{join.confFrame.name}}</td>
                }
                @if (!join.confFrame) {
                  <td>-</td>
                }
                @if (join.sashFrame) {
                  <td>#{{join.sashFrame.id}} - {{join.sashFrame.name}}</td>
                }
                @if (!join.sashFrame) {
                  <td>-</td>
                }
                @if (join.glazingBead) {
                  <td>#{{join.glazingBead.id}} - {{join.glazingBead.name}}</td>
                }
                @if (!join.glazingBead) {
                  <td>-</td>
                }
                @if (join.divider) {
                  <td colspan="2">#{{join.divider.id}} - {{join.divider.name}}</td>
                }
                @if (!join.divider) {
                  <td colspan="2">-</td>
                }
                <td>{{ sash.data.values.Af[i] | number:'1.3-3' }}</td>
                <td>{{ sash.data.values.Sf[i] | number:'1.3-3' }}</td>
                <td>{{ sash.data.values.Uf[i] | number:'1.3-3' }}</td>
              </tr>
            }
          </table>
        </div>
      }
    </div>
  }
</div>
